import { render } from "./LanguageSelection.vue?vue&type=template&id=1034d096&scoped=true"
import script from "./LanguageSelection.vue?vue&type=script&lang=js"
export * from "./LanguageSelection.vue?vue&type=script&lang=js"

import "./LanguageSelection.vue?vue&type=style&index=0&id=1034d096&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1034d096"]])

export default __exports__